import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const StatAPI = {
	weeklyRPE: async (params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/RpesV2",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	monthlyRPE: async (params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/RpesV2",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	weeklyTQR: async (params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/TqrsV2",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	monthlyTQR: async (params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/TqrsV2",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	trainingsDetails: async (playerId, params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/PlayerTrainingsDetailV2/" + playerId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	weeklyTrainings: async (playerId, params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/PlayerTrainingsDetailV2/" + playerId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	matchesDetails: async (playerId, params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/PlayerMatchesDetailV2/" + playerId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
};
